import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import configureStore from "store";
import { BrowserRouter } from "react-router-dom";
import { GlobalHistory } from "routes/globalRoutes";
import rootSaga from "store/sagas";

const { persistor, store } = configureStore();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
store.runSaga(rootSaga);

root.render(
  // <React.StrictMode>
  <ReduxProvider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <GlobalHistory />
        <App />
      </BrowserRouter>
    </PersistGate>
  </ReduxProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
